import { DefaultRawDatum, PieTooltipProps, ResponsivePie } from "@nivo/pie";
import { ReactElement } from "react";
import { Css, px } from "src/Css";
import { centsToDollars, generatedColors } from "src/utils";
import tinycolor from "tinycolor2";

const tooltipHeight = 50;
const tooltipBr = 50 / 2;

const theme = {
  tooltip: {
    // removes default white box around tooltip
    container: {
      padding: 0,
      borderRadius: tooltipBr,
    },
  },
};

export interface DonutProps {
  data: DefaultRawDatum[];
  innerContent?: ReactElement;
  size: number;
}

export function Donut({ data, innerContent, size }: DonutProps) {
  return (
    <div css={Css.hPx(size).relative.$}>
      <ResponsivePie
        data={data}
        theme={theme}
        colors={generatedColors}
        enableArcLinkLabels={false}
        enableArcLabels={false}
        innerRadius={0.85}
        padAngle={0.5}
        tooltip={DonutTooltip}
      />
      {/* TODO: constrain inner content to stay within the donut */}
      <div css={Css.absolute.top0.right0.bottom0.left0.df.fdc.jcc.tac.add("pointerEvents", "none").$}>
        {innerContent}
      </div>
    </div>
  );
}

export function DonutTooltip(props: PieTooltipProps<DefaultRawDatum>) {
  const { color, label, value } = props.datum;
  // lightenAmount: more lightening for darker colors, less for lighter colors
  const lightenAmount = tinycolor(color).getBrightness() > 120 ? 30 : 45;

  return (
    <div
      css={
        Css.df.aic.jcc.pl1.pr3
          .hPx(tooltipHeight)
          .add("borderRadius", px(tooltipBr))
          .add("backgroundColor", tinycolor(color).lighten(lightenAmount).toString()).$
      }
    >
      <div css={Css.h1.w1.br100.bgColor(color).$} aria-hidden="true"></div>
      <div css={Css.pl1.t14.tal.$}>
        <div>{label}</div>
        <div css={Css.gray600.$}>{centsToDollars(value, 0)}</div>
      </div>
    </div>
  );
}
